import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Ref para el contenedor de scroll del contenido
export const mainContentRef = { current: null as HTMLElement | null };

export function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // El scroll real está en el window (layout usa min-h-screen, no h-screen)
    window.scrollTo(0, 0);
    // Fallback por si algún día el <main> llega a tener overflow
    if (mainContentRef.current) {
      mainContentRef.current.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return null;
}
